/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import { cloneElement, Fragment, useEffect, useState } from 'react';
import type { MouseEvent, ReactElement } from 'react';

import get from 'lodash/get';

import { FlexStyled } from '../Block/Flexbox';

interface ITabs {
    active?: number;
    children: ReactElement[];
}

const Tabs = (props: ITabs) => {
    const { active: activeProps, children } = props;
    const [active, setActive] = useState(activeProps || 0);

    useEffect(() => {
        if (activeProps === undefined) return;

        setActive(activeProps);
    }, [activeProps]);

    const onTab = (e: MouseEvent<HTMLDivElement>) => {
        setActive(+get(e.target, 'dataset.index', 0));
    };

    return (
        <Fragment>
            <FlexStyled className="tab__header mb-3" width="100%">
                {
                    children.map((child, index) => {
                        return cloneElement(child, {
                            className: `tab__item ${index === active ? 'active' : ''}`,
                            index: index,
                            key: child.props.label + index,
                            onClick: (e: MouseEvent<HTMLDivElement>) => {
                                onTab(e);
                                child.props.onClick?.();
                            },
                        });
                    })
                }
            </FlexStyled>
            {
                children.map((child, index) => {
                    if (child.props.label === children[active].props.label) {
                        return cloneElement(child.props.children, {
                            className: `${child.props.className || ''} ${index === active ? 'active' : ''}`,
                            key: child.props.label + index,
                        });
                    }
                    return null;
                })
            }
        </Fragment>
    );
};

export default Tabs;
